import React from 'react';
import PropTypes from 'prop-types';
import colors from '@general/colors';

const ArrowRightIcon = ({ color = colors.secondary, style = {} }) => (
    <svg style={style} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 8.5H15.5" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M10.5 3.5L15.5 8.5L10.5 13.5"
            stroke={color}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

ArrowRightIcon.propTypes = {
    color: PropTypes.string,
    style: PropTypes.object,
};

export default ArrowRightIcon;
